/* istanbul ignore file */
import { useRef, useEffect } from 'react'

// This is useful when you want to fire an effect only after you've mounted.
// Useful for example if you have memoized objects you want to export from
// custom hooks but only when they change after the initial construction
const useUpdateEffect = (effect, deps) => {
  const mounted = useRef(false)

  useEffect(() => {
    if (mounted.current) {
      return effect()
    }

    mounted.current = true
  }, deps)
}

export default useUpdateEffect
